import COMPANY from './company.js'
const COMPANY_CONFIG = {
  mady: {
    name: 'mady',
    title: '',
    work: {
      appid: 'ww1d897a6ba4cd151b',
      agentid: '1000022'
    },
    wx: {
      appid: 'wx64c5b8eeedf7bc72'
    },
    url: '/',
    login: {
      default: 'name',
      wx: true,
      work: true,
      name: true
    },
    watermark:
      '?x-oss-process=image/auto-orient,1/quality,q_90/sharpen,100/watermark,image_ZmlsZS93YXRlcm1hcmsvbG9nby5wbmc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF8xNQ,g_nw,t_70,x_10,y_10'
  }
}
// 不要在 config 文件里直接操作 DOM，建议在 App.vue 或 main.js 里设置 title 和 favicon
// if (typeof window !== 'undefined' && typeof document !== 'undefined') {
//   document.getElementsByTagName("title")[0].innerText = COMPANY_CONFIG[COMPANY].title
//   if (COMPANY_CONFIG[COMPANY].ico) {
//     document.getElementsByTagName("link")[0].href = COMPANY_CONFIG[COMPANY].ico
//   }
// }
export default COMPANY_CONFIG[COMPANY]
